import React from 'react';
import { Link } from 'react-router-dom';

function Strip(props) {
  return (
    <div className='strip container-fluid home' style={{ backgroundImage: "url(/images/cover_home2_light.jpg)" }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6" >
            <div>
              <h1 className='text-md-end text-center mt-5 mt-md-0'>המנוי שיכין אותך לשוק העבודה בהייטק בתחום ה FULLSTACK</h1>
              <h4 className='my-4 mx-auto col-9 col-md-12'>MONKEYS PASS - לימוד כל שפות הפיתוח פולסטאק 
              WEB במקום אחד מ רמת מתחיל עד לרמת מקצוען בשוק העבודה</h4>
              <div className='text-center text-md-end'>
                <Link to="/courses_vod"  className='btn-start btn px-4 mb-3 h4' style={{color:"white",fontWeight:"bold"}}>צפה בקורסים שלנו</Link>
                
              </div>
            </div>
          </div>
          <div className="col-md-6 text-dark">
            <div className="bg-white rounded col-11 me-auto  my-card mx-auto  mx-md-0 me-md-auto my-4 my-md-0" >
              <div className='bg-card rounded' style={{ backgroundImage: "url(/images/cover_home2.jpg)" }}></div>
              <div className="card-body">
                <h4 className="card-title text-end">מנוי פרימיום לכל חבילת הקורסים:</h4>
                <p className="card-text">מרגיש תקוע ומתוסכל עם לימוד חומר חדש בפולסטאק או תקוע עם חומר של הכיתה?  הרשם היום למאנקיס פרימיום וקבל מעל 500 סרטונים שיסבירו לך בצורה הפשוטה יותר את כל הנושאים הקריטים בעולם הפולסטאק וויב</p>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Strip